// store/slices/projectSlice.js - Project state slice

export const createProjectSlice = (set) => ({
  // State
  currentProject: null,
  projects: [],

  // Actions
  setCurrentProject: (project) => set({ currentProject: project }),
  setProjects: (projects) => set({ projects }),
  updateProjectMetadata: (metadata) => set((state) => ({
    currentProject: state.currentProject ? {
      ...state.currentProject,
      ...metadata
    } : null
  })),
});
